import { combineReducers } from 'redux';

import * as fromlib from '../../lib/stackup';
import name, * as fromName from './name';
import partNumber, * as fromPartNumber from './partNumber';
import type, * as fromType from './type';
import layers, * as fromLayers from './layers';
import newStackupSpec, * as fromNewSpec from './newStackupSpec';


const stackup = combineReducers({
  name,
  partNumber,
  type,
  layers,
  newStackupSpec,
});

export function getDefaultCore(state){
  return fromlib.getDefaultCore(state);
}

export function getDefaultPrepreg(state){
  return fromlib.getDefaultPrepreg(state);
}

export function getDefaultCopper(state){
  return fromlib.getDefaultInnerCopper(state);
}

export function getStackupType(state) {
  return fromType.getType(state.type);
}

export function getStackupLayers(state) {
  return fromLayers.getLayers(state.layers);
}

export function getStackupLayer(state, key) {
  return fromLayers.getLayer(state.layers, key);
}

export function getMirrorLayer(state, index) {
  return fromLayers.getMirrorLayer(state.layers, index);
}

export function getExtraCoreCount(state) {
  const coreCount = fromLayers.getCoreCount(state.layers);
  const stackupType = fromType.getType(state.type);

  return fromlib.calculateExtraCoreCount(stackupType, coreCount);
}

export function getNeighborPrepreg(state, currentIndex, above) {
  return fromLayers.getNeighborPrepreg(state.layers, currentIndex, above);
}

export function getMirrorNeighborPrepreg(state, currentIndex, above) {
  return fromLayers.getMirrorNeighborPrepreg(state.layers, currentIndex, above);
}

export function getCoreMaterialsInUse(state) {
  return fromLayers.getCoreMaterialsInUse(state.layers);
}

export function getPrepregMaterialsInUse(state) {
  return fromLayers.getPrepregMaterialsInUse(state.layers);
}

export function getCoppersInUse(state) {
  return fromLayers.getCoppersInUse(state.layers);
}

export function getStackup(state){
  return state;
}

export function getStackupToExport(state) {
  const { name, partNumber, type, layers } = state;
  return { name, partNumber, type, layers };
}

export function getDefaultCoreSpec(state){
  return fromNewSpec.getDefaultCoreSpec(state.newStackupSpec);
}

export function getDefaultPrepregSpec(state){
  return fromNewSpec.getDefaultPrepregSpec(state.newStackupSpec);
}

export function getDefaultInnerCopperSpec(state){
  return fromNewSpec.getDefaultInnerCopperSpec(state.newStackupSpec);
}

export function getDefaultResinId(state) {
  return  fromNewSpec.getDefaultResinId(state.newStackupSpec);
}

export function getCopperCount(state) {
  return fromLayers.getCopperCount(state.layers);
}

export function getProjectTitle(state) {
  const name = fromName.getName(state.name);
  const partNumber = fromPartNumber.getPartNumber(state.partNumber);

  return partNumber ? `${name} (${partNumber})` : name;
}

export default stackup;



// WEBPACK FOOTER //
// ./src/reducers/stackup/index.js